const socialMedia = {
  socialsDescription: Drupal.t(
    'Enjoy the latest news from our Social Media channels.',
  ),
  socialsTitle: Drupal.t('Stay connected'),
};

export default socialMedia;
